import { apiRequest } from '@client/lib/apiRequest';
import type { ICity } from '@typings/api/ICity';

export async function getCities(country: number): Promise<ICity[]> {
    const result = await apiRequest<ICity[]>('getCityList', { country });

    return result.ok ? result.result : [];
}
